function popupImage() {
  var popup = document.getElementById('js-popup');
  if(!popup) return;

  var blackBg = document.getElementById('js-black-bg');
  var closeBtn = document.getElementById('js-close-btn');
  var showBtn = document.getElementById('js-show-popup');

  closePopUp(blackBg);
  closePopUp(closeBtn);
  closePopUp(showBtn);
  function closePopUp(elem) {
    if(!elem) return;
    elem.addEventListener('click', function() {
      popup.classList.toggle('is-show');
    });
  }
}
popupImage();

function popupImage02() {
  var popup = document.getElementById('js-popup02');
  if(!popup) return;

  var blackBg = document.getElementById('js-black-bg02');
  var closeBtn = document.getElementById('js-close-btn02');
  var showBtn = document.getElementById('js-show-popup02');

  closePopUp(blackBg);
  closePopUp(closeBtn);
  closePopUp(showBtn);
  function closePopUp(elem) {
    if(!elem) return;
    elem.addEventListener('click', function() {
      popup.classList.toggle('is-show');
    });
  }
}
popupImage02();

// オンライン予約モーダル
function popupImage03() {
  var popup = document.getElementById('js-popup03');
  if(!popup) return;

  var blackBg = document.getElementById('js-black-bg03');
  var closeBtn = document.getElementById('js-close-btn03');
  var showBtn = document.getElementById('js-show-popup03');

  closePopUp(blackBg);
  closePopUp(closeBtn);
  closePopUp(showBtn);
  function closePopUp(elem) {
    if(!elem) return;
    elem.addEventListener('click', function() {
      popup.classList.toggle('is-show');
    });
  }
}
popupImage03();